import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import {
  fetchTowns,
  exportTownToWeb,
} from '../../../modules/portal-remote/portalService'
import { setTown } from '../../../actions/town'
import CopyToClipboard from '../../views/widgets/CopyToClipboard'
import QRCodeButton from '../qrcode/QRCodeButton'
import config from '../../../config'

class TownListContainer extends Component {
  state = {}

  componentDidMount() {
    this.requestTowns()
  }

  requestTowns = async () => {
    try {
      const towns = await fetchTowns()
      this.setState({ towns })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleTownSelect = town => {
    this.props.actions.setTown(town)
    this.props.history.push(`towns/${town._id}/listings`)
  }

  handleExportTownToWeb = townID => {
    exportTownToWeb(townID)
      .then(data => {
        const town = _.find(data, { _id: townID })

        this.setState(
          prevState => ({
            towns: _.map(prevState.towns, _town => {
              if (_town._id === town._id) {
                return town
              } else {
                return _town
              }
            }),
          }),
          () => {
            toast.success(`Export town ${townID} to web success.`)
          },
        )
      })
      .catch(error => toast.error(`Export town to web error: ${error.message}`))
  }

  isTownExported(town) {
    const modifiedDate = _.get(town, 'modifiedDate')
    const lastUpdatedElastic = _.get(town, 'lastUpdatedElastic')
    if (modifiedDate && lastUpdatedElastic) {
      return moment(modifiedDate).isSameOrBefore(lastUpdatedElastic)
        ? 'completed'
        : 'processing'
    }

    if (modifiedDate) {
      return 'processing'
    }
    return 'none'
  }

  getStyleTownExport(town) {
    if (this.isTownExported(town) === 'none') {
      return 'is-warning'
    } else {
      return 'is-primary'
    }
  }

  render() {
    return (
      <div>
        <table className="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Title</th>
              <th>Link</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {_.map(this.state.towns, town => (
              <tr key={town._id} onClick={() => this.handleTownSelect(town)}>
                <td>{town.title[this.props.language]}</td>
                <td>
                  <CopyToClipboard text={town.dynamicLink}>
                    <QRCodeButton
                      title="QR CODE TOWN"
                      text={town.dynamicLink}
                    />
                  </CopyToClipboard>
                </td>
                <td>
                  {_.includes(config.adminTowns, config.subPrefix) && (
                    <button
                      className={`button ${this.getStyleTownExport(
                        town,
                      )} heading`}
                      onClick={e => {
                        e.stopPropagation()
                        this.handleExportTownToWeb(town._id)
                      }}
                    >
                      {this.isTownExported(town) === 'none'
                        ? 'export web'
                        : `exported web ${
                            this.isTownExported(town) === 'completed'
                              ? ''
                              : 'processing'
                          }`}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default connect(
  ({ info: { language } }) => ({ language }),
  dispatch => ({ actions: bindActionCreators({ setTown: setTown }, dispatch) }),
)(TownListContainer)



// WEBPACK FOOTER //
// ./src/components/templates/town-list/TownListContainer.js